function getPackageHasLoyaltyUpgrade(pkg: App.HotelPackage): boolean {
  return !!(pkg.loyalty.upgradeTargetsUniqueKeys?.room || pkg.loyalty.upgradeTargetsUniqueKeys?.package)
}

export default getPackageHasLoyaltyUpgrade
